<template>
  <div class="d-flex p-4 flex-wrap viewOffset" width="80%">
    <div v-for="p in printers" :key="p.index">
      <PrinterCard :printer="p"></PrinterCard>
    </div>
    <h3 v-if="printers.length == 0" class="m-4 fst-italic text-muted">No printers available...</h3>
  </div>
</template>

<script setup>
import { usePrinterStore } from '@/stores/printers';
import PrinterCard from '../cards/PrinterCard.vue';

const printerStore = usePrinterStore();
const printers = printerStore.printers;

</script>

<style scoped>
.viewOffset {
  margin-top: 130px;
}
</style>